/* Shared presentational primitives for the pure-custom wireframe UI. */
import type { ReactNode } from "react";

export type PillTone = "neutral" | "active" | "red" | "green" | "amber" | "blue";

const PILL_CLASS: Record<PillTone, string> = {
  neutral: "pill",
  active: "pill pill--active",
  red: "pill pill--red",
  green: "pill pill--green",
  amber: "pill pill--amber",
  blue: "pill pill--blue",
};

export function Pill({ tone = "neutral", children }: { tone?: PillTone; children: ReactNode }) {
  return <span className={PILL_CLASS[tone]}>{children}</span>;
}

export function PageHead({
  eyebrow,
  title,
  subtitle,
  actions,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="page-head">
      <div className="page-head__text">
        {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {actions ? <div className="actions">{actions}</div> : null}
    </div>
  );
}

export function Spinner() {
  return <span className="spinner" aria-label="Loading" />;
}
